import { FC, useEffect, useState } from "react";
import { getPsychologistMonthlyFinancialValues, PsychologistFinancialValues } from "src/apis/psychologist";
import PageContainer from "src/pages/components/PageContainer";
import FinancialControlTable from "./components/FinancialControlTable";
import { isUserPsychologist } from "src/utils/auth";

const FinancialControl: FC = (): JSX.Element => {
  const [values, setValues] = useState<PsychologistFinancialValues|undefined>();
  const [error, setError] = useState<string>('');

  const fetchData = async (): Promise<void> => {
    try {
      const res = await getPsychologistMonthlyFinancialValues();

      setValues(res);
      setError('');
    } catch (err: any) {
      setError(err?.message);
    }
  }

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <PageContainer title="Controle financeiro" error={error} guard={isUserPsychologist}>
      <FinancialControlTable values={values} />
    </PageContainer>
  );
}

export default FinancialControl;
